const CHANGED_RESTAURANT_EVENT = 'ChangedRestaurantEvent'
const LOADING_EVENT = 'LoadingEvent'
const UNLOADING_EVENT = 'UnloadingEvent'
const OPENINGTIME_WARNING_EVENT = 'OpeningTimeWarningEvent'
const CLIENT_TIMEOUT_EVENT = 'ClientTimeoutEvent'
const SERVER_EXCEPTION_EVENT = 'ServerExceptiontEvent'
const EXCEPTION_EVENT = 'ExceptiontEvent'

const RESET_EVENT = 'ResetAllEvent'

export {
    CHANGED_RESTAURANT_EVENT,
    LOADING_EVENT,
    UNLOADING_EVENT,
    OPENINGTIME_WARNING_EVENT,
    CLIENT_TIMEOUT_EVENT,
    SERVER_EXCEPTION_EVENT,
    EXCEPTION_EVENT,
    RESET_EVENT
}